import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {Amplify} from 'aws-amplify'
import {Chart, registerables} from 'chart.js'
import {createRoot} from 'react-dom/client'
import {CognitoAuthProvider} from './app/modules/auth'
import {AuthErrorProvider} from './app/modules/auth/core/AuthErrorProvider'
import {AppRoutes} from './app/routing/AppRoutes'
import {awsConfig} from './aws-config'
import {worker} from './mocks/browser'
import './ui/assets/sass/style.react.scss'
import './ui/assets/sass/style.scss'

import {I18nProvider} from './shared/i18n/i18n'
import {ThemeProvider} from './shared/theme/ThemeContext'

if (process.env.REACT_APP_ENV === 'TEST') worker.start()
Amplify.configure(awsConfig)

Chart.register(...registerables)

const queryClient = new QueryClient({defaultOptions: {queries: {refetchOnWindowFocus: false}}})
const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      {/* The ToastContainer lives inside the router (see AppRoutes): toast bodies are ordinary
          components, and some of them link to a page. */}
      <I18nProvider>
        <CognitoAuthProvider>
          <AuthErrorProvider>
            <AppRoutes />
          </AuthErrorProvider>
        </CognitoAuthProvider>
      </I18nProvider>
    </ThemeProvider>
  </QueryClientProvider>
)
